(() => {
  'use strict';

  const sharedCity = 'https://cdn.shopify.com/s/files/1/0991/5741/0160/files/kimhc-hero-shared-city-branded.png?v=1784709798';
  const team = 'https://cdn.shopify.com/s/files/1/0991/5741/0160/files/kimhc-hero-move-together-branded.png?v=1784709819';
  const boss = 'https://cdn.shopify.com/s/files/1/0991/5741/0160/files/kimhc-hero-move-like-a-boss-branded.png?v=1784709839';
  const vitals = 'https://cdn.shopify.com/s/files/1/0991/5741/0160/files/kimhc-hero-vitals-collection-branded.png?v=1784709867';
  const reorder = 'https://cdn.shopify.com/s/files/1/0991/5741/0160/files/kimhc-hero-reorder-branded.png?v=1784709890';
  const contact = 'https://cdn.shopify.com/s/files/1/0991/5741/0160/files/kimhc-hero-contact-branded.png?v=1784709915';
  const support = 'https://cdn.shopify.com/s/files/1/0991/5741/0160/files/kimhc-hero-help-legal-branded.png?v=1784709936';

  const heroByPath = {
    '/': { url: sharedCity, alt: 'KIMHC vital professionals wearing branded apparel in the city' },
    '/pages/home-page': { url: sharedCity, alt: 'KIMHC vital professionals wearing branded apparel in the city' },
    '/pages/move-solo': { url: sharedCity, alt: 'KIMHC vital professionals wearing branded apparel in the city' },
    '/pages/about-us': { url: sharedCity, alt: 'KIMHC vital professionals wearing branded apparel in the city' },
    '/pages/showroom': { url: sharedCity, alt: 'KIMHC vital professionals wearing branded apparel in the city' },
    '/pages/move-together': { url: team, alt: 'KIMHC professional team wearing coordinated branded apparel' },
    '/pages/vip-teams': { url: team, alt: 'KIMHC professional team wearing coordinated branded apparel' },
    '/pages/vp-teams': { url: team, alt: 'KIMHC professional team wearing coordinated branded apparel' },
    '/pages/movement-dictionary': { url: team, alt: 'KIMHC professionals wearing coordinated branded apparel' },
    '/pages/the-vitals-community': { url: team, alt: 'The KIMHC Vitals Community in branded apparel' },
    '/pages/move-like-a-boss': { url: boss, alt: 'KIMHC Vitalpreneurs in a premium branded apparel showroom' },
    '/pages/vitals-collection': { url: vitals, alt: 'The KIMHC Vitals Collection campaign' },
    '/pages/reorder': { url: reorder, alt: 'KIMHC reorder support with branded apparel and inventory' },
    '/pages/contact': { url: contact, alt: 'Friendly KIMHC team wearing branded apparel' },
    '/pages/help-center': { url: support, alt: 'KIMHC support professionals wearing branded apparel' },
    '/pages/legal': { url: support, alt: 'KIMHC professionals providing trusted support' },
    '/pages/digital-courses-scrub-scout': { url: support, alt: 'KIMHC professionals providing trusted support' }
  };

  const normalizePath = () => window.location.pathname.replace(/\/+$/, '') || '/';

  const applyHero = () => {
    const path = normalizePath();
    const assignment = heroByPath[path];
    if (!assignment) return;

    const heroImage = document.querySelector('.khb-hero__image, .kim-solo__hero-image, .kp-hero__image');

    if (heroImage) {
      const picture = heroImage.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach((source) => source.remove());
      }
      heroImage.removeAttribute('srcset');
      heroImage.removeAttribute('sizes');
      heroImage.src = assignment.url;
      heroImage.alt = assignment.alt;
      heroImage.loading = 'eager';
      heroImage.setAttribute('fetchpriority', 'high');
      heroImage.dataset.kimhcHero = path;
      return;
    }

    const shell = document.querySelector('.kp-hero, .khb-hero, .kim-solo__hero');
    if (!shell) return;

    const fallback = document.createElement('img');
    fallback.src = assignment.url;
    fallback.alt = assignment.alt;
    fallback.loading = 'eager';
    fallback.setAttribute('fetchpriority', 'high');
    fallback.dataset.kimhcHero = path;
    fallback.className = shell.classList.contains('kp-hero')
      ? 'kp-hero__image'
      : shell.classList.contains('khb-hero')
        ? 'khb-hero__image'
        : 'kim-solo__hero-image';
    shell.prepend(fallback);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHero, { once: true });
  } else {
    applyHero();
  }

  document.addEventListener('shopify:section:load', applyHero);
})();

/*
 * Shopify Forms popup frequency guard.
 * The form may show once during each browser-tab session, remain dismissed for
 * the rest of that session, and become eligible again in a genuinely new session.
 */
(() => {
  'use strict';

  const sessionMarker = 'kimhc_shopify_forms_session_ready_v5';
  const retryDelays = [0, 200, 650];
  const exactSuppressionKeys = new Set([
    'forms_previous_session_id',
    'forms_fallback_session_id',
    'forms_visit_count'
  ]);

  const isSuppressionKey = (key) => {
    if (!key) return false;

    const normalized = String(key).toLowerCase();
    if (exactSuppressionKeys.has(normalized)) return true;
    if (/-(dismissed|minimized)-in-session$/.test(normalized)) return true;

    const belongsToForms = normalized.includes('forms') || normalized.includes('shopify');
    const suppressesDisplay = /dismiss|minimiz|previous_session|fallback_session|visit_count/.test(normalized);
    return belongsToForms && suppressesDisplay;
  };

  const clearSuppressionState = () => {
    [window.localStorage, window.sessionStorage].forEach((storage) => {
      const keysToRemove = [];

      for (let index = 0; index < storage.length; index += 1) {
        const key = storage.key(index);
        if (key !== sessionMarker && isSuppressionKey(key)) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach((key) => storage.removeItem(key));
    });
  };

  try {
    if (window.sessionStorage.getItem(sessionMarker)) return;

    window.sessionStorage.setItem(sessionMarker, '1');
    retryDelays.forEach((delay) => window.setTimeout(clearSuppressionState, delay));
  } catch (error) {
    /* Storage can be unavailable in restrictive privacy modes. Fail safely. */
  }
})();

/* Canonical KIMHC pathway navigation for desktop and mobile. */
(() => {
  'use strict';

  const pathways = [
    { href: '/pages/move-like-a-boss', label: 'Vitalpreneurs' },
    { href: '/pages/move-together', label: 'Vital Professional Teams' },
    { href: '/pages/move-solo', label: 'Vital Professionals' }
  ];

  const setActiveState = (link) => {
    if (window.location.pathname === link.getAttribute('href')) {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }
  };

  const normalizePathwayNavigation = () => {
    const header = document.querySelector('.kph');
    if (!header) return;

    /* Move Solo is a pathway page, not a Shop dropdown item. */
    header.querySelectorAll('.kph__panel a[href="/pages/move-solo"]').forEach((link) => link.remove());

    const desktopNav = header.querySelector('.kph__nav');
    if (desktopNav) {
      const existingMovementLinks = Array.from(
        desktopNav.querySelectorAll(':scope > a.kph__link')
      ).filter((link) => [
        '/pages/move-solo',
        '/pages/move-together',
        '/pages/vp-teams',
        '/pages/move-like-a-boss'
      ].includes(link.getAttribute('href')));

      existingMovementLinks.forEach((link) => link.remove());

      const reference = desktopNav.querySelector(':scope > a[href="/pages/vitals-collection"]');
      pathways.forEach(({ href, label }) => {
        const link = document.createElement('a');
        link.className = 'kph__link';
        link.href = href;
        link.textContent = label;
        setActiveState(link);
        desktopNav.insertBefore(link, reference);
      });
    }

    const drawerGroup = header.querySelector('.kph__drawer-group');
    if (drawerGroup) {
      Array.from(drawerGroup.querySelectorAll(':scope > a.kph__link'))
        .filter((link) => [
          '/pages/move-solo',
          '/pages/move-together',
          '/pages/vp-teams',
          '/pages/move-like-a-boss'
        ].includes(link.getAttribute('href')))
        .forEach((link) => link.remove());

      const reference = drawerGroup.querySelector(':scope > a[href="/pages/vitals-collection"]');
      pathways.forEach(({ href, label }) => {
        const link = document.createElement('a');
        link.className = 'kph__link';
        link.href = href;
        link.textContent = label;
        setActiveState(link);
        drawerGroup.insertBefore(link, reference);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizePathwayNavigation, { once: true });
  } else {
    normalizePathwayNavigation();
  }

  document.addEventListener('shopify:section:load', normalizePathwayNavigation);
})();
